import { useContext } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import Loader from '../components/Loader';
import './AuthStatusPage.scss';

export default function EntraCallback() {
  const {
    authError,
    authToken,
    isInitialized,
    lastAuthResult,
    logout,
    user,
  } = useContext(UserContext);

  if (authError) {
    // E.g. the email already has a password account (no automatic linking), or
    // the account isn't allowed in the current rollout mode.
    return (
      <div className="auth-status-page" dir="rtl">
        <h1>ההתחברות לא הושלמה</h1>
        <p role="alert">{authError}</p>
        {/* Signs out of Microsoft and returns to /signin, to try another account. */}
        <button type="button" className="auth-status-primary" onClick={() => logout()}>
          התחברות עם חשבון אחר
        </button>
        <Link to="/login" className="auth-status-link">כניסה עם סיסמה</Link>
      </div>
    );
  }

  if (!authToken || !isInitialized || !lastAuthResult) {
    return <Loader isLoading={true} />;
  }

  if (lastAuthResult.isNew || ['profile', 'workplace'].includes(user?.entraOnboarding?.status)) {
    return <Navigate replace to="/onboarding/register" />;
  }

  // Back from Microsoft's two-step verification: return where the user was.
  const returnTo = lastAuthResult.returnTo || '';
  // Same-site paths only ('//host' would leave the site).
  if (lastAuthResult.intent === 'mfa' && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    return <Navigate replace to={returnTo} />;
  }

  return <Navigate replace to="/homepage" />;
}
